export default __webpack_public_path__ + "static/media/contact-icon.353a346f.svg";